import dynamic from 'next/dynamic';
import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import { Chart } from './components';
import { chartOptionsHandler } from './utils';
async function load(app, options = {}) {
  const {
    defaultColourScheme,
    datasetsColourSchemes,
    animationDuration
  } = options;
  chartOptionsHandler.setDefaultColourScheme(defaultColourScheme);
  chartOptionsHandler.setDatasetsColourSchemes(datasetsColourSchemes);
  chartOptionsHandler.setAnimationDuration(animationDuration);
  app.events.once('load:custom:page-builder:component', addComponent => {
    addComponent({
      key: 'chart',
      component: dynamic(() => import(/* webpackChunkName: "blazePbChart" */'./components/ChartFeWrapper'))
    });
  });
  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}
load.pluginName = PLUGIN_NAME;
export { Chart };
export default load;
//# sourceMappingURL=index.js.map